





















































































































































































































































































































































































































































































































































































































import { DateTime } from "luxon";
import { Component, Vue } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import { PageInfo } from "@/model/Resp";
import pluginDialog from "./components/pluginDialog.vue";
import { fetchPublishGate, PublishGateView } from "./components/shopifyThemeGate";
import TemplateSelectDialog from "./components/TemplateSelectDialog.vue";
import CartRecommendBanner from "./components/CartRecommendBanner.vue";
import SmartAbCreateDialog, { SMART_AB_PRESET, SmartAbPresetType } from "./components/SmartAbCreateDialog.vue";
import { formRulesEditPath, isAllTriggerConditionsSelected, parseFormRules } from "./abtest/triggerPresetGuard";
import { RecommendItem, CART_RECOMMEND_SOURCE, CART_RECOMMEND_TEMPLATE_ID, CART_RECOMMEND_CREATE_TYPE } from "./components/recommend/types";
import { fetchCartRecommendQualification, dismissCartRecommend } from "@/services/cartRecommend";
import { isEnableCartRecommendMvp, isCartRecommendMockEnabled, isEnableFormAbSmartTest } from "@/utils/experiment";
import { TriggerEventType, getTriggerEventTypeName, TriggerEventTypeOptions } from "@/constant/triggerEventType";
import { tx } from "@/i18n/pack";
import { toastFailMessage } from "@/i18n/failMessage";
import {
  closeWheelOfFortune,
  openWheelOfFortune,
  getWheelOfFortuneList,
  getFormStepList,
  companyMeasureSave,
  getCompanyMeasure,
  getWheelOfFortuneExcel,
  setGlobalSetting,
  getGlobalSetting,
  exportDataToEmailWithsub,
  downloadTimes,
  getGuideDetail,
  getTabAuthorityList,
  postPopupDelete,
  createABTest,
  createSmartABTest,
  getFormAbSmartEnabled,
} from "@/services/api";
import {TFormVO} from "@/model/FormWheel";
import {handleExcelRes} from "@/services/common";

import { throttle } from "@/services/common";
import { Message } from "element-ui";
import { isEnableAttributionWindow, isEnableAttributionWindow20260609, isEnableAttributionWindow20260611, isEnableAuth } from "@/utils/experiment";
import { monitor, MonitorEvent } from "@/services/monitor";
import { inAuthority } from "@/utils/authority";
import { isFormPage } from "./pop/utils/stepPages";

interface TemplateSelectItem {
  id: number;
  name: string;
  type: number;
}

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
    pluginDialog,
    TemplateSelectDialog,
    CartRecommendBanner,
    SmartAbCreateDialog,
  },
  methods: {
    handleModalSubmit: throttle(async function () {
      this.$refs.emailFrom.validate(vaild => {
        if (vaild) {
          downloadTimes({
            type: 3,
            businessId: `${this.exportId}`,
          }).then(res =>{
            if (res?.data?.message === 'success' && res?.data?.data >= 4) {
              this.$message.warning(this.$tx('campaign.stats.dataExportErrorContactSupport', '导出数据出现异常？可联系客服人员协助解决'))
            }
          })

          exportDataToEmailWithsub({
            id: this.exportId,
            receiverEmail: this.modalFrom.email
          }).then(res => {
            if (res.status === 200) {
              this.exportWait = true
            } else {
              this.$message.error(this.$tx('form.list.exportFail', '数据导出失败，请重试'));
            }

          })
        } else {
          return false
        }
      })
    }, 3000),
  }
})
export default class wheelOfFortuneList extends Vue {
  // 控制导出数据弹框显示
  exportVisible = false
  //修改数据展示弹框
  dataShowVisible = false
  //订阅工具全局设置弹框
  setToolsdialogVisible = false

  // 导出数据等待页显示state
  exportWait = false
  modalFrom = {
    email: ''
  }

  // 用来记录导出id
  exportId = ''

  oneDay = 24 * 60 * 60 * 1000

  timezone = localStorage.getItem('timezone')?.split(' ')?.[1] || 'Asia/Shanghai'

  TIME_FORMAT = 'yyyy-MM-dd 00:00:00'

  get utcTimeZone() {
    return localStorage.getItem('timezone')?.split(' ')?.[0] || '(GMT+08:00)'
  }

  get enableAuth() {
    return isEnableAuth();
  }

  get enableAttributionWindow() {
    return isEnableAttributionWindow();
  }

  //筛选时间
  public date = [
    DateTime.now().setZone(this.timezone).toFormat(this.TIME_FORMAT),
    DateTime.now().setZone(this.timezone).toFormat(this.TIME_FORMAT)
  ]
  public initialDate = [...this.date]
  public shortcutsDateIndex = 0

  get dateList() {
    return [
    {
      desc: tx(null, 'form.list.today', '今天'),
      value: [
        DateTime.now().setZone(this.timezone).toFormat(this.TIME_FORMAT),
        DateTime.now().setZone(this.timezone).toFormat(this.TIME_FORMAT)
      ]
    },
    {
      desc: tx(null, 'form.list.yesterday', '昨天'),
      value: [
        DateTime.now().setZone(this.timezone).minus({days: 1}).toFormat(this.TIME_FORMAT),
        DateTime.now().setZone(this.timezone).minus({days: 1}).toFormat(this.TIME_FORMAT),
      ]
    },
    {
      desc: tx(null, 'form.list.last7', '近7天'),
      value: [
        DateTime.now().setZone(this.timezone).minus({days: 6}).toFormat(this.TIME_FORMAT),
        DateTime.now().setZone(this.timezone).toFormat(this.TIME_FORMAT),
      ]
    },
    {
      desc: tx(null, 'form.list.last30', '近30天'),
      value: [
        DateTime.now().setZone(this.timezone).minus({days: 29}).toFormat(this.TIME_FORMAT),
        DateTime.now().setZone(this.timezone).toFormat(this.TIME_FORMAT),
      ]
    }
    ]
  }

  public selectShortcutsTime(date, index){
    this.date = date.value;
    this.shortcutsDateIndex = index
    this.getWheelOfFortuneList(this.date[0], this.date[1]);
  }

  public pickerOptions = {
    disabledDate: (time) => {
      const currentTime = time.getTime();
      const now = new Date(DateTime.now().setZone(this.timezone).toFormat('yyyy/MM/dd HH:mm:ss')).getTime();
      const last90 = new Date(DateTime.now().setZone(this.timezone).minus({days: 90}).toFormat('yyyy/MM/dd HH:mm:ss')).getTime();
      return currentTime > now || currentTime < last90;
    }
  }

  get columnsMap() {
    return {
    'viewCnt': tx(null, 'form.list.col.impressions', '曝光用户数'),
    'signupCnt': tx(null, 'form.list.col.submits', '提交用户数'),
    'signupRate': tx(null, 'form.list.col.conv', '提交转化率'),
    ...(this.enableAttributionWindow ? {
      'orderGmv': tx(null, 'form.list.col.sales', '销售额'),
      'orderCnt': tx(null, 'form.list.col.orders', '订单数'),
      'orderAtv': tx(null, 'form.list.col.aov', '客单价')
    } : {}),
    'phoneCnt': tx(null, 'form.list.col.phone', '收集手机号总量'),
    'emailCnt': tx(null, 'form.list.col.email', '收集邮箱总量'),
    'birthdayCnt': tx(null, 'form.list.col.birthday', '收集生日总量'),
    ...(this.enableAuth ? {
      'loginEmailCnt': tx(null, 'form.list.col.loginEmail', '第三方登录收集邮箱总量'),
      'loginSignUpCnt': tx(null, 'form.list.col.loginSignup', '第三方登录提交用户数')
    } : {}),
    }
  }

  attributionStartTime = isEnableAttributionWindow20260609()
    ? '2026-06-09'
    : isEnableAttributionWindow20260611()
      ? '2026-06-11'
      : '2026-06-16'

  get metricTooltipMap() {
    return {
    orderCnt: tx(null, 'form.list.tooltip.orderCnt', '该弹窗引导产生的订单数（基于用户弹窗提交的邮箱/手机号匹配归因）；未触发归因起点的弹窗（如无提交步骤 / 未到达成功页）显示为 0；指标自 {{date}} 起生效。', { date: this.attributionStartTime }),
    orderGmv: tx(null, 'form.list.tooltip.orderGmv', '该弹窗引导产生的订单销售额汇总（基于用户弹窗提交的邮箱/手机号匹配归因）；未触发归因起点的弹窗显示为 0；指标自 {{date}} 起生效。', { date: this.attributionStartTime }),
    orderAtv: tx(null, 'form.list.tooltip.orderAtv', '该弹窗引导下订单的平均金额，计算方式为 归因销售额 ÷ 归因订单数；订单数为 0 时显示为 0；指标自 {{date}} 起生效。', { date: this.attributionStartTime })
    }
  }

  public selectedColumn: any[] = []
  public lastSelectedColumn: any[] = []

  public tableColumnsList = []
  public selectColumnsList = [
    'viewCnt',
    ...(this.enableAuth ? ['loginEmailCnt'] : []),
    'signupCnt',
    ...(this.enableAuth ? ['loginSignUpCnt'] : []),
    'signupRate',
    ...(this.enableAttributionWindow
      ? ['orderGmv', 'orderCnt', 'orderAtv'] as any
      : []
    ),
    'phoneCnt',
    'emailCnt',
    'birthdayCnt'
  ];

  public get availableMeasureColumns() {
    return new Set(this.selectColumnsList);
  }

  public filterValidMeasures(measures: string[] = []) {
    return measures.filter((measure) => this.availableMeasureColumns.has(measure));
  }


  // 弹窗类型选项，用于筛选下拉

  // 获取触发事件类型名称
  getNameFromType(type: number) {
    if (type === null || type === undefined) {
      return '-';
    }
    return tx(null, `form.list.type.${type}`, '-');
  }

  getStatusLabel(status: number) {
    const map: Record<number, [string, string]> = {
      0: ['form.list.status.off', this.$tx('common.close', '关闭')],
      1: ['form.list.status.on', this.$tx('form.enabled', '开启')],
      3: ['form.list.status.draft', '草稿'],
      4: ['form.list.status.pending', '待开始'],
      5: ['form.list.status.ended', '已结束'],
    };
    const hit = map[status];
    return hit ? tx(null, hit[0], hit[1]) : '-';
  }

  // 不支持 A/B 测试的弹窗类型（到货提醒、嵌入式表单、自定义触发表单）
  abTestUnsupportedTypes = [
    TriggerEventType.BACK_IN_STOCK,
    TriggerEventType.EMBEDDED_FORM,
    TriggerEventType.CUSTOM_TRIGGER
  ] as number[]

  /** Smart Test MVP：创建快捷配置弹层（companyInfo.formAbSmartTestOpen） */
  enableFormAbSmartTest = isEnableFormAbSmartTest();
  smartAbCreateVisible = false;
  smartAbCreateRoundNo = 1;
  smartAbCreateFormId: string | null = null;
  smartAbCreateForm: { id: string; type?: number; settings?: unknown } | null = null;
  triggerBlockedVisible = false;

  // 筛选表单数据
  filterForm = {
    name: '',
    triggerEventType: null as number | null,
    status: null as number | null
  }

  // 排序状态
  // sortField = ''      // 排序字段：viewCnt, signupCnt, signupRate 等
  // sortOrder = ''      // 排序方向：ascending, descending

  // 弹窗类型选项（与 typeNames 对应，使用 triggerEventType 字段）
  get typeOptions() {
    return [
    { label: tx(null, 'form.list.typeAll', '全部类型'), value: null },
    { label: tx(null, 'form.list.type.0', '新用户订阅'), value: 0 },
    { label: tx(null, 'form.list.type.1', '离开挽留'), value: 1 },
    { label: tx(null, 'form.list.type.2', '加购订阅'), value: 2 },
    { label: tx(null, 'form.list.type.3', '优惠券承接'), value: 3 },
    { label: tx(null, 'form.list.type.4', '老用户召回'), value: 4 },
    { label: tx(null, 'form.list.type.5', '弃单挽留'), value: 5 },
    { label: tx(null, 'form.list.type.6', '到货提醒'), value: 6 },
    { label: tx(null, 'form.list.type.7', '嵌入式表单'), value: 7 },
    { label: tx(null, 'form.list.type.8', '自定义触发'), value: 8 }
    ]
  }

  // 根据权限过滤后的弹窗类型选项
  get filteredTypeOptions() {
    // 保留 "全部类型" 选项，过滤其他选项
    return this.typeOptions.filter(option => {
      // 全部类型 (value: null) 始终显示
      if (option.value === null) return true;
      // 根据 tabAuthList 判断是否显示该类型
      return this.tabAuthList.includes(option.value);
    });
  }

  // 订阅状态选项
  get statusOptions() {
    return [
    { label: tx(null, 'form.list.statusAll', '全部状态'), value: null },
    { label: tx(null, 'form.list.status.on', '开启'), value: 1 },
    { label: tx(null, 'form.list.status.off', '关闭'), value: 0 },
    { label: tx(null, 'form.list.status.draft', '草稿'), value: 3 },
    { label: tx(null, 'form.list.status.pending', '待开始'), value: 4 },
    { label: tx(null, 'form.list.status.ended', '已结束'), value: 5 }
    ]
  }

  public openDataShowVisible(){
    //记录上次的选中值
    this.lastSelectedColumn = JSON.parse(JSON.stringify(this.selectedColumn))
    this.dataShowVisible = true;
  }

  public cancleDataShowVisible(){
    //取消将原来的值恢复
    this.selectedColumn = JSON.parse(JSON.stringify(this.lastSelectedColumn))
    this.dataShowVisible = false;
  }

  public sureDataShowVisible(){
    this.dataShowVisible = false;
    this.tableColumnsList = this.selectedColumn
    companyMeasureSave({
      measureCategory: "FORM",
      measures: this.selectedColumn
    }, true).then((res) => {
      // console.log('保存成功');
    })
    window?.gtagClick('form_list_editItem','弹窗_列表_点击修改数据项')
  }

  public getCompanyMeasure(){
    getCompanyMeasure({
      measureCategory: "FORM"
    }, true).then((res) => {
      const measures = this.filterValidMeasures(res.data.data.measures || []);
      if(measures.length){
        this.selectedColumn = measures;
        this.tableColumnsList = measures;
      }else{
        this.selectedColumn = this.tableColumnsList = [
          'viewCnt',
          'signupCnt',
          'signupRate',
          ...(this.enableAttributionWindow
            ? ['orderGmv', 'orderCnt', 'orderAtv'] as any
            : []
          )
        ];
      }
    })
  }


  public tableData: TFormVO[] = [];

  public pageInfo: PageInfo = {
    currentPage: 1,
    pageSize: 20,
    total: 0,
  };

  public rules: any = {
    email: [
      {
        trigger: "change",
        validator: (rule: any, value: any, callback: any) => {
          // 限制中文和空格的输入且只允许输入40个字符
          this.modalFrom.email = value.replace(/[\u4E00-\u9FA5 ]/g, '').slice(0, 40)
          if (!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(value)) {
            callback(new Error(tx(null, 'form.list.emailInvalid', '请输入正确的邮箱地址')));
          } else {
            callback();
          }
        },
      },
      { required: true, message: tx(null, 'form.list.exportEmailPh', '请输入邮箱地址'), trigger: 'blur' },
    ]
    }

  dialogVisible = false
  createList = []
  createListIndex = -1
  createType = 0
  templateid = 1
  templateName = ''
  createSource = ''
  templateDialogDefaultType: number | null = null
  templateDialogAutoCreate = false
  cartRecommendVisible = false
  cartRecommendItems: RecommendItem[] = []
  cartRecommendDismissLoading = false
  cartRecommendMeta: { recommendationId?: string; targetScene?: number } = {}
  loading = false
  companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id
  xikeCompanyId = [431, 459, 450, 461, 453, 472, 468, 470, 465, 457, 467, 469, 403, 639]

  maps = new Map()

  isDialog(id) {
    this.exportVisible = true
    this.exportId = id
    // 模拟点击空白处用来关闭popover
    document.body.click();
  }

  handleModalCancle() {
    this.exportVisible = false
    this.exportWait = false
  }
  gaClickFun(key:string,name:string){
    window?.gtagClick(key,name)
  }

  public getGuideDetail() {
    return getGuideDetail({}).then(res =>{
      localStorage.setItem('companyInfo',JSON.stringify(res?.data?.data?.companyInfo||'{}'))
      this.enableFormAbSmartTest = isEnableFormAbSmartTest();
    });
  }

  tabAuthList = [0]

  public getCompanyTabAuth() {
    getTabAuthorityList({}, false).then((res) => {
      this.tabAuthList = res.data.data.tabAuthorityList || [0];
    });
  }
  public hasType(number: number) {
    return this.tabAuthList.includes(Number(number));
  }
  public inAuthorityFun(menu:any,key:any){
    return inAuthority(menu,key)
  }

  installBlocked = false;
  plugInDialogShow = false;
  inPop = false;
  inPopupId = null;
  isShopify = false;
  gateMode = '';
  authorizationUrl = '';
  recheckMessage = '';
  safety = JSON.parse(localStorage.getItem('dataMaskingOpen'))

  public applyPublishGate(view: PublishGateView, showDialog: boolean) {
    this.gateMode = view.mode;
    this.authorizationUrl = view.authorizationUrl;
    this.recheckMessage = view.recheckMessage;
    this.installBlocked = !view.pass;
    if (view.integrationType === 1) {
      this.isShopify = true;
      sessionStorage.setItem('isShopify', '1');
    } else if (view.integrationType) {
      this.isShopify = false;
      sessionStorage.setItem('isShopify', '0');
    }
    if (showDialog) {
      this.plugInDialogShow = !view.pass;
    }
    return view.pass;
  }

  public async ensurePublishGate(recheck: boolean, showDialog = true) {
    const view = await fetchPublishGate(this.isShopify, recheck, (key, fallback) => this.$tx(key, fallback));
    return this.applyPublishGate(view, showDialog);
  }

  public checkPluginInstall() {
    this.plugInDialogShow = false;
    this.inPop = false;
    this.ensurePublishGate(false, false);
  }
  public async showPlugInDialog() {
    const passed = await this.ensurePublishGate(false, true);
    if (passed) {
      this.installBlocked = false;
    }
    this.inPop = false;
  }
  public closePluginDialog() {
    this.inPop = false;
    this.plugInDialogShow = false;
    this.recheckMessage = '';
  }
  public async confirmPluginDialog() {
    if (this.gateMode === 'shopline') {
      this.plugInDialogShow = false;
      this.inPop = false;
      if (this.inPopupId) {
        this.openWheelOfFortune(this.inPopupId);
        this.inPopupId = null;
      }
      return;
    }
    const passed = await this.ensurePublishGate(true, true);
    if (!passed) {
      return;
    }
    this.plugInDialogShow = false;
    this.inPop = false;
    if (this.inPopupId) {
      this.openWheelOfFortune(this.inPopupId);
      this.inPopupId = null;
    }
  }
  public async openPopup(popupid:any) {
    window?.gtagClick('form_list_enable','弹窗_列表_开启')
    const passed = await this.ensurePublishGate(false, false);
    if (!passed) {
      this.inPopupId = popupid;
      this.inPop = true;
      this.plugInDialogShow = true;
      return;
    }
    this.openWheelOfFortune(popupid);
    this.inPopupId = null;
  }

  created(): void {
    window?.gtagNew('event', 'form_list_view', {
      event_name:'弹窗_列表_浏览',
      event_type:'页面曝光',
      Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
      login_id:JSON.parse(localStorage.getItem('displayInfo'))?.id,
      login_type:JSON.parse(localStorage.getItem('displayInfo'))?.innerUserType,
      path_url:window.location.href,
      time:new Date()
    });
    this.getWheelOfFortuneList(this.date[0], this.date[1]);
    setInterval(() => {
      this.getWheelOfFortuneList(this.date[0], this.date[1]);
    }, 10 * 60 * 1000)
    //展示保存的数据项
    this.getCompanyMeasure()
    // 获取公司信息
    this.getGuideDetail();
    // 请求该公司能够显示的订阅类型，默认为[0]
    this.getCompanyTabAuth();
    // 检查是否需要安装插件
    this.checkPluginInstall();
    if(!this.inAuthorityFun('wheel_of_fortune/list','view')){
      this.$router.push('/403');
    }
    this.loadCartRecommendQualification();
  }

  async loadCartRecommendQualification() {
    if (!isEnableCartRecommendMvp() || !this.inAuthorityFun('wheel_of_fortune/list', 'edit')) {
      return;
    }
    try {
      const result = await fetchCartRecommendQualification(false);
      if (!result.eligible || !result.items?.length) {
        this.cartRecommendVisible = false;
        this.cartRecommendItems = [];
        return;
      }
      this.cartRecommendMeta = {
        recommendationId: result.recommendationId,
        targetScene: result.targetScene,
      };
      this.cartRecommendItems = result.items;
      this.cartRecommendVisible = true;
    } catch (error) {
      this.cartRecommendVisible = false;
      this.cartRecommendItems = [];
    }
  }

  handleCartRecommendPreview(item: RecommendItem) {
    // 推荐入口：跳过模板库，直接进入模板 98 编辑页
    this.createSource = CART_RECOMMEND_SOURCE;
    this.templateid = CART_RECOMMEND_TEMPLATE_ID;
    this.createType = CART_RECOMMEND_CREATE_TYPE;
    this.templateName = item.titleHighlight || this.$tx('form.recommend.titleHighlight', '【新客加购订阅弹窗】');
    this.createToRoute();
  }

  async handleCartRecommendDismiss(item: RecommendItem) {
    this.cartRecommendDismissLoading = true;
    try {
      const response = await dismissCartRecommend({
        companyId: this.companyId,
        recommendationId: this.cartRecommendMeta.recommendationId,
        targetScene: item.scene ?? this.cartRecommendMeta.targetScene,
      }, true);
      if (response?.status !== 200) {
        throw new Error('dismiss failed');
      }
      if (response.data?.code != null && response.data.code !== 0) {
        throw new Error(response.data.message || 'dismiss failed');
      }
    } catch (error) {
      if (!isCartRecommendMockEnabled()) {
        this.$message.error(this.$tx('common.opFailedRetry', '操作失败，请重试'));
        return;
      }
    } finally {
      this.cartRecommendDismissLoading = false;
    }

    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;
    window?.gtagClick?.('form_list_cartRecommend_dismiss', '弹窗_列表_加购推荐点击暂不推荐', [
      { key: 'targetScene', value: String(item.scene || this.cartRecommendMeta.targetScene || 2) },
      { key: 'company_id', value: String(companyId || '') },
    ]);
    this.cartRecommendVisible = false;
    this.cartRecommendItems = [];
  }

  resetTemplateDialogRecommendState() {
    this.templateDialogDefaultType = null;
    this.templateDialogAutoCreate = false;
  }

  handleClose(done:any){
    done()
  }

  displayFrequency:number = 1

  displayFrequencyValue = 'm'

  get displayFrequencyOptions() {
    return [
      {label: this.$tx('form.list.minute', '分钟'), value: 'm'},
      {label: this.$tx('form.list.second', '秒'), value: 's'},
    ]
  }

  popLimitTimes:number = 2

  attributionWindow = '2h'

  get attributionWindowOptions() {
    return [
      { label: this.$tx('form.list.attr.15m', '15分钟'), value: '15m' },
      { label: this.$tx('form.list.attr.30m', '30分钟'), value: '30m' },
      { label: this.$tx('form.list.attr.60m', '60分钟'), value: '60m' },
      { label: this.$tx('form.list.attr.2h', '2小时'), value: '2h' },
      { label: this.$tx('form.list.attr.24h', '24小时'), value: '24h' }
    ]
  }

  attributionStartBehavior = 'submit_any_step'

  get attributionStartBehaviorOptions() {
    return [
      { label: this.$tx('form.list.attr.submitAny', '任一步骤提交成功'), value: 'submit_any_step' },
      { label: this.$tx('form.list.attr.submitSuccess', '提交完成到达成功页'), value: 'submit_success_page' }
    ]
  }

  activeName = 0

  handlePopType() {
    // 先清空列表
    this.createList = []
    // 再请求新数据
    this.create()
    switch (Number(this.activeName)) {
        case 0:
          window?.gtagClick('form_create_templateSubForm','弹窗_创建订阅工具_查看模板库_订阅弹窗')
          break;
        case 1:
          window?.gtagClick('form_create_templateExitForm','弹窗_创建订阅工具_查看模板库_退出意图弹窗')
          break;
        case 2:
          window?.gtagClick('form_create_templateCartForm','弹窗_创建订阅工具_查看模板库_加购弹窗')
          break;
        case 3:
          window?.gtagClick('form_create_templateEmailForm','弹窗_创建订阅工具_查看模板库_邮件承接弹窗')
          break;
        case 4:
          window?.gtagClick('form_create_templateRetention','弹窗_创建订阅工具_查看模板库_老用户召回弹窗')
          break;
        case 5:
          window?.gtagClick('form_create_templateRecovery','弹窗_创建订阅工具_查看模板库_弃单挽留弹窗')
          break;
        case 6:
          window?.gtagClick('form_create_templateRestock','弹窗_创建订阅工具_查看模板库_到货提醒')
          break;
        case 7:
          window?.gtagClick('form_create_templateEmbedded','弹窗_创建订阅工具_查看模板库_嵌入式表单')
          break;
        case 8:
          window?.gtagClick('form_create_templateCustom', '弹窗_创建订阅工具_查看模板库_自定义触发器');
          break;
        default:
          break;
    }
  }


  async create(){
    this.resetTemplateDialogRecommendState();
    this.createSource = '';
    this.dialogVisible =true
    window?.gtagNew('event', 'form_create_viewTemplates', {
      event_name:'弹窗_创建订阅工具_查看模板库',
      event_type:'页面曝光',
      Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
      login_id:JSON.parse(localStorage.getItem('displayInfo'))?.id,
      login_type:JSON.parse(localStorage.getItem('displayInfo'))?.innerUserType,
      path_url:window.location.href,
      time:new Date()
    });
  }

  handleCreateTemplate(template: TemplateSelectItem) {
    this.templateid = template.id
    this.templateName = template.name
    this.createType = template.type
    this.createToRoute()
  }

  get shopType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (companyInfo.integrationType) {
      return companyInfo.integrationType?.toLowerCase();
    }
    return ``;
  }

  createClick(item:any,index:number){
    if(item.isShow){
      this.templateid = item.id
      this.templateName = item.name
      this.createListIndex = index + 1
      this.createType = item.type
    }
  }
  clickCancel(){
    window.gtag('event', 'subscribe-tool_create_cancel', {
      event_name:'取消创建订阅工具',
      event_type:'按钮点击',
      event_des:'取消创建订阅工具',
      Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
      os_type:JSON.parse(localStorage.getItem('osInfo'))?.os,
      os_version:JSON.parse(localStorage.getItem('osInfo'))?.version,
      browser_type:JSON.parse(localStorage.getItem('browserInfo'))?.browser,
      browser_version:JSON.parse(localStorage.getItem('browserInfo'))?.version,
      conutry:localStorage.getItem('countryName'),
      time:new Date()
    });
    this.dialogVisible = false
  }
  createToRoute(){
    window.gtag('event', 'subscribe-tool_create', {
      event_name:'创建订阅工具',
      event_type:'按钮点击',
      event_des:'创建订阅工具',
      subscribe_type:this.templateName,
      Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
      os_type:JSON.parse(localStorage.getItem('osInfo'))?.os,
      os_version:JSON.parse(localStorage.getItem('osInfo'))?.version,
      browser_type:JSON.parse(localStorage.getItem('browserInfo'))?.browser,
      browser_version:JSON.parse(localStorage.getItem('browserInfo'))?.version,
      conutry:localStorage.getItem('countryName'),
      time:new Date()
    });
    window?.gtagClick('form_create_selectTemplate','弹窗_创建订阅工具_选择一个模板创建',[
      {
        key:'data-template-id',
        value:this.templateid
      }
    ])
    const queryParts = [`templateid=${this.templateid}`];
    if (this.createSource) {
      queryParts.push(`source=${encodeURIComponent(this.createSource)}`);
      queryParts.push(`target_scene=2`);
    }
    const query = queryParts.join('&');
    if (this.createType === 1) {
       this.$router.push(`/wheel_of_fortune/setting?${query}`)
    }else if (this.createType === 2){
      this.$router.push(`/wheel_of_fortune/pop?${query}`)
    }
    this.createSource = '';
    this.resetTemplateDialogRecommendState();
  }
  getWheelOfFortuneList(startDate, endDate) {
    const params: any = {
      startDate: startDate,
      endDate: endDate,
      currentPage: this.pageInfo.currentPage,
      pageSize: this.pageInfo.pageSize,
    };
    // 添加筛选参数（仅在有值时传递）
    if (this.filterForm.name && this.filterForm.name.trim()) {
      params.name = this.filterForm.name.trim();
    }
    if (this.filterForm.triggerEventType !== null && this.filterForm.triggerEventType !== undefined) {
      params.triggerEventType = this.filterForm.triggerEventType;
    }
    if (this.filterForm.status !== null && this.filterForm.status !== undefined) {
      params.status = this.filterForm.status;
    }
    // 添加排序参数
    // if (this.sortField && this.sortOrder) {
    //   params.sortField = this.sortField;
    //   params.sortOrder = this.sortOrder === 'ascending' ? 'asc' : 'desc';
    // }
    getWheelOfFortuneList(params, true).then((res) => {
      this.tableData = res.data.data;
      this.loading = true;
      if (res.data.pageInfo) {
        this.pageInfo = res.data.pageInfo;
      }
      for(let form of this.tableData) {
        if (form.viewCnt < form.signupCnt) {
          monitor({
            event: MonitorEvent.Error,
            function: 'getWheelOfFortuneList',
            data: {
              ext1: JSON.stringify(form)
            },
          });
          form.viewCnt = form.signupCnt;
        }
        form.signupRate = form.signupCnt == -1 ? form.signupCnt : (form.signupCnt ? (form.signupCnt / form.viewCnt * 100).toFixed(2) + '%': '0');
        if (form.stepDisplay || form.coverDisplay === 1) {
          form['hasChildren'] = (form.stepDisplay || form.coverDisplay === 1) && form.abStatus !== 1
          //重新获取分步骤数据
          if(this.maps.size != 0){
            let map = this.maps.get(form.id);
            if(map){
              const { treeNode, resolve } = map
              this.load(form, treeNode, resolve)
            }
          }
        }
      }
    });
  }

  changeDate(value){
    this.shortcutsDateIndex = -1;
    // 日期变化时重置排序
    // this.sortField = '';
    // this.sortOrder = '';
    // 清除表格排序状态
    if (this.$refs.tableList) {
      (this.$refs.tableList as any).clearSort();
    }
    this.getWheelOfFortuneList(value[0], value[1]);
  }

  load(tree, treeNode, resolve){
    this.maps.set(tree.id, { tree, treeNode, resolve })
    this.getFormStepList(tree, this.date[0], this.date[1], resolve)
  }

  getConfiguredFormSteps(tree: any): number[] {
    try {
      const settings = typeof tree?.settings === 'string' ? JSON.parse(tree.settings) : tree?.settings;
      const pageSettings = Array.isArray(settings?.pageSettings) ? settings.pageSettings : [];
      return pageSettings.filter((item: any) => isFormPage(item?.value)).slice(0, 5).map((_: any, index: number) => index + 1);
    } catch (e) {
      return [];
    }
  }

  buildEmptyStepRow(step: number) {
    return {
      step,
      viewCnt: 0,
      signupCnt: 0,
      emailCnt: 0,
      phoneCnt: 0,
      birthdayCnt: 0,
      loginEmailCnt: 0,
      loginSignUpCnt: 0,
    };
  }

  getFormStepList(tree, startDate, endDate, resolve){
    getFormStepList({
      formId: tree.id,
      startDate: startDate,
      endDate: endDate
    }, true).then((res: any) => {
      const stepNameMap: Record<number, string> = { [-1]: this.$tx('form.edit.step.cover', '封面'), 1: this.$tx('form.step1', '第一步'), 2: this.$tx('form.step2', '第二步'), 3: this.$tx('form.step3', '第三步'), 4: this.$tx('form.step4', '第四步'), 5: this.$tx('form.step5', '第五步') }
      const apiList = Array.isArray(res.data.data) ? res.data.data : [];
      const configuredSteps = this.getConfiguredFormSteps(tree);
      const apiStepMap = new Map<number, any>();
      const coverList: any[] = [];

      apiList.forEach((element: any, index: number) => {
        const step = typeof element.step === 'number'
          ? element.step
          : (apiList?.[0]?.step === -1 ? index : index + 1);
        if (step === -1) {
          coverList.push({ ...element, step });
        } else {
          apiStepMap.set(step, { ...element, step });
        }
      });

      const list = configuredSteps.length
        ? [...coverList, ...configuredSteps.map((step: number) => apiStepMap.get(step) || this.buildEmptyStepRow(step))]
        : [...coverList, ...Array.from(apiStepMap.values())];

      list.forEach((element: any, index: number) => {
        if (apiList?.[0]?.step === -1 || element.step === -1) {
          element.name = stepNameMap[element.step] || stepNameMap[index] || this.$tx('form.list.nthStep', '第{{n}}步', { n: index })
        } else {
          element.name = stepNameMap[element.step] || stepNameMap[index + 1] || this.$tx('form.list.nthStep', '第{{n}}步', { n: index + 1 })
        }
        element.id = `${tree.id}-${element.step || index}`
        if (element.viewCnt < element.signupCnt) {
          element.viewCnt = element.signupCnt;
        }
        element['signupRate'] = element.viewCnt? (element.signupCnt? (element.signupCnt / element.viewCnt * 100).toFixed(2) + '%': '0'): '';

        // 封面
        if (element.step === -1) {
          element.phoneCnt = '-';
          element.signupCnt = '-';
          element.signupRate = '-';
          element.emailCnt = '-';
          element.birthdayCnt = '-';
          element.loginEmailCnt = '-';
          element.loginSignUpCnt = '-';
        }
        element.orderAtv = '-';
        element.orderCnt = '-';
        element.orderGmv = '-';
      });
      resolve(list)
    }).catch(() => {
      resolve([])
    });
  }
  Edit(scope:any){
    if(!this.inAuthorityFun('wheel_of_fortune/list','edit')){
      return
    }
    if (scope.row?.abStatus === 1) {
      Message.error(this.$tx('form.bTestIsRunningSource', '已有运行中A/B测试实验，暂无法修改源弹窗'));
    } else if (scope.row.status === 5) {
      Message.error(this.$tx('form.completedPopupsCannotBeEdited', '已结束订阅工具不允许编辑'));
    } else if (scope.row.type == 1) {
      this.$router.push(`/wheel_of_fortune/setting/${scope.row.id}`)
    }else if(scope.row.type == 2){
      this.$router.push(`/wheel_of_fortune/pop/${scope.row.id}`)
    }
  }

  async editAbTest(scope:any) {
    // 创建AB测试
    if (scope.row.abStatus != null && scope.row.abStatus !== 2) {
        this.$router.push(`/wheel_of_fortune/abtest/${scope.row.id}`);
        window?.gtagNew('event','form_abTest_edit', {
          event_name:'弹窗_编辑ab测试',
          event_type:'页面曝光',
          Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
          login_id:JSON.parse(localStorage.getItem('displayInfo'))?.id,
          login_type:JSON.parse(localStorage.getItem('displayInfo'))?.innerUserType,
          path_url:window.location.href,
          time:new Date()
        });
    } else {
      if (scope.row.scheduleType === 1) {
        this.$message({
          message: this.$tx('form.thisPopupHasScheduledActivation', '该弹窗已设置生效时间，无法创建A/B测试'),
          type: 'warning'
        });
        return;
      }
      this.enableFormAbSmartTest = isEnableFormAbSmartTest();
      if (!this.enableFormAbSmartTest) {
        try {
          const res: any = await getFormAbSmartEnabled({});
          this.enableFormAbSmartTest = res?.data?.data === true;
        } catch (e) {
          // 仍走 companyInfo；失败则旧创建
        }
      }
      if (this.enableFormAbSmartTest) {
        this.smartAbCreateFormId = scope.row.id;
        this.smartAbCreateForm = {
          id: scope.row.id,
          type: scope.row.type,
          settings: scope.row.settings,
        };
        this.smartAbCreateRoundNo = 1;
        this.smartAbCreateVisible = true;
        return;
      }
      this.createAbTestAndEnter(scope.row.id);
    }
  }

  onSmartAbPresetSelect(presetType: SmartAbPresetType) {
    const formId = this.smartAbCreateFormId;
    if (!formId) {
      return;
    }
    if (
      presetType === SMART_AB_PRESET.TRIGGER
      && isAllTriggerConditionsSelected(parseFormRules(this.smartAbCreateForm?.settings))
    ) {
      this.triggerBlockedVisible = true;
      return;
    }
    this.smartAbCreateVisible = false;
    createSmartABTest({ id: formId, presetType }).then(() => {
      this.$router.push(`/wheel_of_fortune/abtest/${formId}`);
    });
    window?.gtagClick('form_list_createABTest','弹窗_列表_新建AB测试')
  }

  confirmGoEditTriggers() {
    const form = this.smartAbCreateForm;
    this.triggerBlockedVisible = false;
    this.smartAbCreateVisible = false;
    if (form?.id) {
      this.$router.push(formRulesEditPath(form.id, form.type));
    }
  }

  createAbTestAndEnter(formId: string) {
    createABTest({id: formId}).then(() => {
      this.$router.push(`/wheel_of_fortune/abtest/${formId}`);
    });
    window?.gtagClick('form_list_createABTest','弹窗_列表_新建AB测试')
  }

  Copy(scope:any){
    window?.gtagClick('form_list_duplicate','弹窗_列表_复制')
    if (scope.row.type == 1) {
      this.$router.push(`/wheel_of_fortune/setting/copy/${scope.row.id}`)
    }else if(scope.row.type == 2){
      this.$router.push(`/wheel_of_fortune/pop/copy/${scope.row.id}`)
    }
  }

  async setGlobalSetting(){

    if(!this.displayFrequency){
      this.$message({
        message: this.$tx('form.list.quietRequired', '请设置静默期时间'),
        type: 'warning'
      });
      return
    }

    if(!this.popLimitTimes){
      this.$message({
        message: this.$tx('form.list.popLimitRequired', '请设置触发弹窗上限'),
        type: 'warning'
      });
      return
    }

    let {data, status } = await setGlobalSetting({
      "quiescentState": 1, //静默期状态: 1开启,0关闭
      "quiescentPeriod": this.displayFrequencyValue == 'm' ? this.displayFrequency * 60 : this.displayFrequency, //静默期时间,单位秒
      "maxTrigger": this.popLimitTimes, //弹窗触发上限
      ...(this.enableAttributionWindow ? {
        "attributionWindow": this.attributionWindow,
        "attributionStartBehavior": this.attributionStartBehavior
      } : {}),
    },true)

    if (status == 200) {
      this.setToolsdialogVisible = false
    }
  }

  openGlobalSetting(){
    this.setToolsdialogVisible = true
    this.getGlobalSetting()
  }

  async getGlobalSetting(){
    let {data, status } = await getGlobalSetting({},true)
    if (status == 200) {
      const quiescentPeriod = data.data.quiescentPeriod;
      this.displayFrequency = quiescentPeriod >= 60 ? quiescentPeriod / 60 : quiescentPeriod
      this.displayFrequencyValue = quiescentPeriod >= 60 ? 'm' : 's'
      this.popLimitTimes = data.data.maxTrigger
      this.attributionWindow = data.data.attributionWindow || '2h'
      this.attributionStartBehavior = data.data.attributionStartBehavior || 'submit_any_step'
    }
  }


  /**
   * 关闭幸运轮盘
   */
  async closeWheelOfFortune(id: string) {
    window?.gtagClick('form_list_disable','弹窗_列表_关闭')
    await this.$confirm(
      this.$tx('form.list.closeConfirm', '确定关闭订阅工具吗？'),
      this.$tx('form.list.closeConfirmTitle', '确定关闭吗？'),
      {customClass:'modalOk'}
    );
    closeWheelOfFortune({ id }, true).then(() => {
      this.getWheelOfFortuneList(this.date[0], this.date[1]);
      const app: any = document.querySelector("#app");
      app.click();
    });
  }


  /**
   * 开启幸运轮盘
   */
  async openWheelOfFortune(id: string) {
    // 校验
    const popConfig = this.tableData?.find(item => item.id == id);
    if (popConfig && ['35', '49'].includes(`${popConfig.templateId}`)) {
      const settings = JSON.parse(popConfig.settings);
      const hasLeftAdImage = !!settings?.typesetting?.leftAdImage;
      const hasRightAdImage = !!settings?.typesetting?.rightAdImage;
      const hasMiddleLeftAdImage = !!settings?.typesetting?.middleLeftAdImage;
      const hasMiddleRightAdImage = !!settings?.typesetting?.middleRightAdImage;

      // 仅允许两张都配置 or 两张都不配置（不允许只配一张）
      if (hasLeftAdImage !== hasRightAdImage || hasMiddleLeftAdImage !== hasMiddleRightAdImage) {
        this.$message({
          message: this.$tx('form.bothAdImagesThisTemplate', '该模版广告图需同时配置2张（不可只配置其中1张）'),
          type: 'error'
        });
        return;
      }
    }
    openWheelOfFortune({ id:id }, true).then(() => {
      this.getWheelOfFortuneList(this.date[0], this.date[1]);
      const app: any = document.querySelector("#app");
      app.click();
    }).catch(() => {

    })
  }

  /**
   * 查询
   */
  search(): void {
    this.pageInfo.currentPage = 1;
    this.getWheelOfFortuneList(this.date[0], this.date[1]);
  }

  /**
   * 筛选条件变化处理
   */
  handleFilterChange(): void {
    this.pageInfo.currentPage = 1;
    // 筛选条件变化时重置排序
    // this.sortField = '';
    // this.sortOrder = '';
    // 清除表格排序状态
    if (this.$refs.tableList) {
      (this.$refs.tableList as any).clearSort();
    }
    this.getWheelOfFortuneList(this.date[0], this.date[1]);
  }

  /**
   * 重置筛选条件
   */
  resetFilters(): void {
    this.filterForm = {
      name: '',
      triggerEventType: null,
      status: null
    };
    this.date = [...this.initialDate];
    this.shortcutsDateIndex = 0;
    // 重置排序状态
    // this.sortField = '';
    // this.sortOrder = '';
    // 清除表格排序状态
    if (this.$refs.tableList) {
      (this.$refs.tableList as any).clearSort();
    }
    this.pageInfo.currentPage = 1;
    this.getWheelOfFortuneList(this.date[0], this.date[1]);
  }

  /**
   * 表格排序变化处理
   */
  // handleSortChange({ prop, order }: { prop: string, order: string }): void {
  //   // this.sortField = prop || '';
  //   // this.sortOrder = order || '';
  //   this.pageInfo.currentPage = 1;
  //   this.getWheelOfFortuneList(this.date[0], this.date[1]);
  // }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.pageInfo.pageSize = val;
    this.pageInfo.currentPage = 1;
    this.getWheelOfFortuneList(this.date[0], this.date[1]);
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.pageInfo.currentPage = val;
    this.getWheelOfFortuneList(this.date[0], this.date[1]);
  }

  /**
   * 数据导出
   */
  public excelCtrl = true;
  async getExcel(id: string,signupCnt: number): Promise<void>  {
    if (!signupCnt) {
      this.$message(this.$tx('list.empty.noData', '暂无数据'));
      return;
    }
    if (this.excelCtrl) {
      try {
        this.excelCtrl = false;
        await getWheelOfFortuneExcel({id}).then((res: any) => {
          handleExcelRes(res);
        })
      } catch (e) {}
      this.excelCtrl = true;
    }
  }

  showDeleteDialog = false;
  popDeleteId = '';
  deletePop(id: any) {
    // 删除popup
    this.popDeleteId = id;
    this.showDeleteDialog = true;
  }

  confirmDeletePop() {
    this.showDeleteDialog = false;
    if (!!this.popDeleteId) {
      //删除
      // console.log('确定删除', this.popDeleteId);
      postPopupDelete({id:this.popDeleteId}).then((res) => {
        this.getWheelOfFortuneList(this.date[0], this.date[1]);
        const app: any = document.querySelector("#app");
        app.click();
        Message.success(tx(null, 'form.list.deleteOk', '删除成功'));
        window?.gtagVerify('form_list_deleteSuccess','弹窗_列表_删除_成功')
      }).catch((e) => {
        if (e?.handled) {
          return;
        }
        Message.error(toastFailMessage(e) || tx(null, 'form.list.deleteFail', '删除失败，请重新尝试'));
        window?.gtagVerify('form_list_deleteServiceErr','弹窗_列表_删除_服务异常')
      });
      this.popDeleteId = '';
    }
  }

  showLeftRightAdImage(tempId: any) {
    // 方法不在调用，35模版打开
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    if (!['35', '49'].includes(`${tempId}`)) {
      return true;
    }
    // 显示黑金
    // console.log('显示黑金');
    return ['35', '49'].includes(`${tempId}`) && (companyId === 450 || companyId === 30 || companyId === 313 || companyId === 583);
  }

  showPopZhuanpan(tempId: any) {
    // 方法不再调用，36模版打开全量，弹窗的转盘
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    if (`${tempId}` !== '36') {
      return true;
    }
    return `${tempId}` === '36' && (companyId === 450 || companyId === 30 || companyId === 313 || companyId === 641);
  }

  showCombinationTypeTemplate(tempId: any) {
    // 是否显示最新的多折扣码弹窗
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    if (`${tempId}` !== '40' && `${tempId}` !== '41') {
      return true;
    }
    return (`${tempId}` === '40' || `${tempId}` === '41') && (companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681 || companyId === 441 || companyId === 920 || companyId === 1039 || companyId === 907);
  }

  get openAbTest() {
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    return (companyId === 30 || companyId === 871 || companyId === 907 || companyId === 306 || companyId === 621 || companyId === 565);
  }
}
